import { FC } from "react";
import { Image } from "react-datocms";

import { IResponsiveImage } from "@types";

import s from "./Caption.module.scss";

interface Props {
  author?: string;
  image?: IResponsiveImage;
  authorFunction?: string;
}

export const Caption: FC<Props> = ({ image, author, authorFunction }) => {
  return (
    <figcaption className={s.Caption}>
      {image && (
        <div className={s.CaptionImage}>
          <Image data={image.responsiveImage} />
        </div>
      )}
      {(author || authorFunction) && (
        <div className={s.CaptionContent}>
          {author} {authorFunction && <cite className={s.CaptionFunction}>{authorFunction}</cite>}
        </div>
      )}
    </figcaption>
  );
};
